import { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api/axios';
import styles from './MensajesPage.module.css';

const API_BASE = 'https://eduportalual.com/backend/api/x7Kp9mQ2';

function etiquetaFecha(fechaStr) {
  const hoy  = new Date();
  const ayer = new Date(); ayer.setDate(ayer.getDate() - 1);
  const f    = new Date(fechaStr);
  const same = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth()    === b.getMonth()    &&
    a.getDate()     === b.getDate();
  if (same(f, hoy))  return 'Hoy';
  if (same(f, ayer)) return 'Ayer';
  return f.toLocaleDateString('es-ES', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' });
}
function claveFecha(s) {
  const d = new Date(s);
  return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
}
function normalizar(s) {
  return String(s).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
}
function esImagen(nombre) {
  return /\.(png|jpg|jpeg|gif|webp)$/i.test(nombre || '');
}
function urlAdjunto(convId, msgId) {
  const token = localStorage.getItem('token');
  const url   = `${API_BASE}/conversaciones/${convId}/adjunto/${msgId}`;
  return url + (token ? '?token=' + encodeURIComponent(token) : '');
}

export default function MensajesPage() {
  const { id: asigId } = useParams();
  const { user }       = useAuth();

  const [conversaciones, setConversaciones] = useState([]);
  const [selected, setSelected]             = useState(null);
  const [usuarios, setUsuarios]             = useState([]);
  const [loading, setLoading]               = useState(true);
  const [loadingConv, setLoadingConv]       = useState(false);
  const [showForm, setShowForm]             = useState(false);
  const [asunto, setAsunto]                 = useState('');
  const [contenido, setContenido]           = useState('');
  const [destinatarios, setDestinatarios]   = useState([]);
  const [busqDest, setBusqDest]             = useState('');
  const [respuesta, setRespuesta]           = useState('');
  const [adjunto, setAdjunto]               = useState(null);
  const [enviando, setEnviando]             = useState(false);
  const adjuntoRef  = useRef(null);
  const mensajesEnd = useRef(null);

  const cargarConversaciones = () =>
    api.get(`/asignaturas/${asigId}/conversaciones`)
      .then(r => setConversaciones(r.data.data || []))
      .finally(() => setLoading(false));

  useEffect(() => {
    cargarConversaciones();
    api.get(`/asignaturas/${asigId}/usuarios`).then(r => setUsuarios(r.data.data || []));
  }, [asigId]);

  useEffect(() => {
    mensajesEnd.current?.scrollIntoView({ behavior: 'smooth' });
  }, [selected]);

  const abrirConversacion = async (conv) => {
    setLoadingConv(true); setShowForm(false);
    try {
      const r    = await api.get(`/conversaciones/${conv.id}`);
      const data = r.data.data;
      if (data) setSelected({ ...data, mensajes: data.mensajes || [], participantes: data.participantes || [] });
      setConversaciones(prev => prev.map(c => c.id === conv.id ? { ...c, leido: 1 } : c));
    } catch (err) { console.error(err); }
    finally { setLoadingConv(false); }
  };

  const crearConversacion = async e => {
    e.preventDefault();
    if (!destinatarios.length) return;
    try {
      const r = await api.post(`/asignaturas/${asigId}/conversaciones`, { asunto, contenido, participantes: destinatarios });
      setShowForm(false); setAsunto(''); setContenido(''); setDestinatarios([]); setBusqDest('');
      await cargarConversaciones();
      const convId = r.data.data?.id;
      if (convId) {
        const c = await api.get(`/conversaciones/${convId}`);
        const d = c.data.data;
        setSelected({ ...d, mensajes: d.mensajes || [], participantes: d.participantes || [] });
      }
    } catch (err) { console.error(err); }
  };

  const enviarRespuesta = async e => {
    e.preventDefault();
    if (!respuesta.trim() && !adjunto) return;
    setEnviando(true);
    try {
      const fd = new FormData();
      fd.append('contenido', respuesta);
      if (adjunto) fd.append('adjunto', adjunto);
      await api.post(`/conversaciones/${selected.id}/responder`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setRespuesta(''); setAdjunto(null);
      if (adjuntoRef.current) adjuntoRef.current.value = '';
      const r = await api.get(`/conversaciones/${selected.id}`);
      setSelected(r.data.data);
      cargarConversaciones();
    } finally { setEnviando(false); }
  };

  const fmtHora  = d => new Date(d).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
  const fmtFecha = d => new Date(d).toLocaleDateString('es-ES', { day: '2-digit', month: 'short' });

  const usuariosFiltrados = usuarios.filter(u =>
    !busqDest || normalizar(`${u.nombre} ${u.apellidos} ${u.email}`).includes(normalizar(busqDest))
  );
  const profesores = usuariosFiltrados.filter(u => u.rol === 'profesor');
  const alumnos    = usuariosFiltrados.filter(u => u.rol === 'alumno');

  const itemsConSeparadores = () => {
    const msgs = selected?.mensajes || [];
    const res  = []; let last = null;
    msgs.forEach(m => {
      const k = claveFecha(m.created_at);
      if (k !== last) { res.push({ tipo: 'sep', fecha: m.created_at, k }); last = k; }
      res.push({ tipo: 'msg', ...m });
    });
    return res;
  };

  return (
    <div className={styles.page}>
      <div className={styles.layout}>

        {/* Sidebar izquierdo */}
        <div className={styles.sidebar}>
          <div className={styles.sidebarHeader}>
            <h3 className={styles.sidebarTitle}>Conversaciones</h3>
            <button className={styles.btnNuevo}
              onClick={() => { setShowForm(p => !p); setSelected(null); }}>
              {showForm ? '✕ Cerrar' : '✏️ Nueva'}
            </button>
          </div>

          {showForm && (
            <form onSubmit={crearConversacion} className={styles.nuevoForm}>
              <input className={styles.input} placeholder="Asunto del mensaje"
                value={asunto} onChange={e => setAsunto(e.target.value)} required />
              <div className={styles.destinatariosSection}>
                <p className={styles.destLabel}>Destinatarios:</p>
                <input className={styles.input}
                  placeholder="🔍 Buscar por nombre..."
                  value={busqDest}
                  onChange={e => setBusqDest(e.target.value)} />
                <div className={styles.destLista}>
                  {profesores.length > 0 && (
                    <div className={styles.rolGroup}>
                      <p className={styles.rolLabel}>👨‍🏫 Profesores</p>
                      {profesores.map(u => (
                        <label key={u.id} className={styles.checkItem}>
                          <input type="checkbox" checked={destinatarios.includes(u.id)}
                            onChange={() => setDestinatarios(prev =>
                              prev.includes(u.id) ? prev.filter(i => i !== u.id) : [...prev, u.id])} />
                          <div className={styles.checkAvatar}>{u.nombre[0]}{u.apellidos[0]}</div>
                          <span>{u.nombre} {u.apellidos}</span>
                        </label>
                      ))}
                    </div>
                  )}
                  {alumnos.length > 0 && (
                    <div className={styles.rolGroup}>
                      <p className={styles.rolLabel}>👩‍🎓 Alumnos</p>
                      {alumnos.map(u => (
                        <label key={u.id} className={styles.checkItem}>
                          <input type="checkbox" checked={destinatarios.includes(u.id)}
                            onChange={() => setDestinatarios(prev =>
                              prev.includes(u.id) ? prev.filter(i => i !== u.id) : [...prev, u.id])} />
                          <div className={styles.checkAvatar}>{u.nombre[0]}{u.apellidos[0]}</div>
                          <span>{u.nombre} {u.apellidos}</span>
                        </label>
                      ))}
                    </div>
                  )}
                  {usuariosFiltrados.length === 0 && busqDest && (
                    <p className={styles.empty}>Sin resultados para "{busqDest}"</p>
                  )}
                </div>
                {destinatarios.length > 0 && (
                  <p className={styles.selCount}>✓ {destinatarios.length} seleccionado(s)</p>
                )}
              </div>
              <textarea className={styles.textarea} placeholder="Escribe tu mensaje..."
                rows="3" value={contenido} onChange={e => setContenido(e.target.value)} required />
              <button type="submit" className={styles.btnEnviar} disabled={!destinatarios.length}>
                Enviar mensaje
              </button>
            </form>
          )}

          <div className={styles.convList}>
            {loading && <p className={styles.empty}>Cargando...</p>}
            {!loading && conversaciones.length === 0 && !showForm && (
              <p className={styles.empty}>No hay conversaciones todavía.</p>
            )}
            {conversaciones.map(conv => (
              <div key={conv.id}
                className={`${styles.convItem} ${selected?.id === conv.id ? styles.convActive : ''} ${!conv.leido ? styles.convUnread : ''}`}
                onClick={() => abrirConversacion(conv)}>
                {!conv.leido && <span className={styles.unreadDot} />}
                <div className={styles.convInfo}>
                  <div className={styles.convItemTop}>
                    <p className={styles.convAsunto}>{conv.asunto}</p>
                    <span className={styles.convFecha}>{fmtFecha(conv.updated_at)}</span>
                  </div>
                  <p className={styles.convMeta}>{conv.creador_nombre} {conv.creador_apellidos}</p>
                  {conv.ultimo_mensaje && <p className={styles.convPreview}>{conv.ultimo_mensaje}</p>}
                </div>
                <span className={styles.convCount}>{conv.total_mensajes}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Panel derecho */}
        <div className={styles.convPanel}>
          {!selected && !loadingConv && (
            <div className={styles.emptyConv}>
              <p className={styles.emptyIcon}>✉️</p>
              <p className={styles.emptyText}>Selecciona una conversación o crea una nueva</p>
            </div>
          )}
          {loadingConv && (
            <div className={styles.emptyConv}><p className={styles.emptyText}>Cargando...</p></div>
          )}
          {selected && !loadingConv && (
            <>
              <div className={styles.convHeader}>
                <div>
                  <h3 className={styles.convTitulo}>{selected.asunto}</h3>
                  <p className={styles.convParticipantes}>
                    👥 {selected.participantes?.map(p => `${p.nombre} ${p.apellidos}`).join(', ')}
                  </p>
                </div>
                <span className={styles.msgTotal}>{selected.mensajes?.length} mensaje(s)</span>
              </div>

              <div className={styles.mensajesList}>
                {itemsConSeparadores().map((item) => {
                  if (item.tipo === 'sep') return (
                    <div key={`sep-${item.k}`} className={styles.fechaSeparador}>
                      <span className={styles.fechaSeparadorTexto}>{etiquetaFecha(item.fecha)}</span>
                    </div>
                  );
                  const m     = item;
                  const esMio = Number(m.autor_id ?? m.usuario_id) === Number(user?.id);
                  return (
                    <div key={m.id} className={`${styles.msgRow} ${esMio ? styles.msgRowMio : styles.msgRowOtro}`}>
                      {!esMio && (
                        <div className={styles.msgAvatar}>
                          {m.autor_nombre?.[0] ?? '?'}{m.autor_apellidos?.[0] ?? ''}
                        </div>
                      )}
                      <div className={`${styles.msgBubble} ${esMio ? styles.msgBubbleMio : styles.msgBubbleOtro}`}>
                        {!esMio && (
                          <p className={styles.msgAutor}>
                            {m.autor_nombre} {m.autor_apellidos}
                            <span className={styles.msgRol}> · {m.autor_rol}</span>
                          </p>
                        )}
                        {m.contenido && <p className={styles.msgTexto}>{m.contenido}</p>}
                        {m.adjunto_nombre && (
                          esImagen(m.adjunto_nombre)
                            ? <img
                                src={urlAdjunto(selected.id, m.id)}
                                alt={m.adjunto_nombre}
                                className={styles.adjuntoImg}
                                onClick={() => window.open(urlAdjunto(selected.id, m.id), '_blank')}
                              />
                            : <button className={styles.adjuntoBtn}
                                onClick={() => window.open(urlAdjunto(selected.id, m.id), '_blank')}>
                                📎 {m.adjunto_nombre}
                              </button>
                        )}
                        <p className={styles.msgHora}>{fmtHora(m.created_at)}</p>
                      </div>
                    </div>
                  );
                })}
                <div ref={mensajesEnd} />
              </div>

              <form onSubmit={enviarRespuesta} className={styles.responderForm}>
                {adjunto && (
                  <div className={styles.adjuntoPrevio}>
                    {esImagen(adjunto.name) ? '🖼️' : '📎'} {adjunto.name}
                    <button type="button"
                      onClick={() => { setAdjunto(null); if (adjuntoRef.current) adjuntoRef.current.value = ''; }}>✕</button>
                  </div>
                )}
                <div className={styles.responderRow}>
                  <textarea className={styles.responderInput}
                    placeholder="Escribe tu respuesta… (Enter envía, Shift+Enter nueva línea)"
                    value={respuesta} onChange={e => setRespuesta(e.target.value)} rows="2"
                    onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); enviarRespuesta(e); } }} />
                  <input ref={adjuntoRef} type="file"
                    accept=".pdf,.doc,.docx,.txt,.zip,.png,.jpg,.jpeg,.gif,.webp"
                    style={{ display: 'none' }}
                    onChange={e => setAdjunto(e.target.files[0] || null)} />
                  <button type="button" className={styles.btnAdjunto}
                    onClick={() => adjuntoRef.current?.click()} title="Adjuntar archivo">📎</button>
                  <button type="submit" className={styles.btnResponder}
                    disabled={enviando || (!respuesta.trim() && !adjunto)}>
                    {enviando ? '…' : '➤'}
                  </button>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
